<template>
  <div class="search-source">
    <div class="mt-1 bg-white border-top border-bottom p-2">
      <h3 class="mb-2"><!--@click="open=!open"-->
        {{hebrew ? 'מקורות' : 'Sources'}}<!-- 
        <i v-if="open" class="fas fa-caret-down"></i>
        <i v-else class="fas fa-caret-up"></i> -->
      </h3>
      <b-form-group class="mb-0" v-if="open">
        <b-form-radio-group class="mb-0" v-model="mode">
          <b-form-radio  value="tanach" class="mb-1" >
            {{hebrew ? 'תנ"ך' : 'Bible'}}
          </b-form-radio>
          <b-form-radio  value="talmud">
            {{hebrew ? 'תלמוד' : 'Talmud'}}
          </b-form-radio>
        </b-form-radio-group>      
      </b-form-group>
    </div>     
  </div>
</template>

<script>
import {Actions} from '@/store/stateChanges'

export default {
  name: 'SearchSource',
  data() {
    return {
      open: true
    }
  },
  props: [],
  methods: {
       
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    complete () {
      return this.$store.state.searchApiState === 'Complete'
    },
    mode: {
      get () {
        return this.$store.state.mode
      },  
      set (value) {
        this.$store.commit('SET_MODE', value)
        this.$store.dispatch(Actions.RUN_SEARCH) 
      }  
    }    
  }
}
</script>
<style>
  .custom-control.custom-radio {
    display: block;
    padding-right: 8px!important;
  }
</style>
<style scoped>
  i {line-height: 23px;}
</style>
